"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const cgui_core_atoms_input_1 = require("@campgladiator/cgui-core.atoms.input");
const header_search_bar_module_scss_1 = __importDefault(require("./header-search-bar.module.scss"));
const getSearchBarIcon = (searchValueLength) => searchValueLength === 0
    ? { type: "solid", name: "icon-search" }
    : { type: "monochrome", name: "times-circle" };
const HeaderSearchBar = (0, react_1.forwardRef)(({ onSearchValueChange, inputSize = "small", changeOnKeyPress, placeholder, className, disabled = false, autofocus = false, }, ref) => {
    const [searchValue, setSearchValue] = (0, react_1.useState)("");
    const handleKeyDown = (event) => {
        if (changeOnKeyPress && changeOnKeyPress == event.key)
            onSearchValueChange(searchValue);
    };
    (0, react_1.useEffect)(() => {
        onSearchValueChange(searchValue);
    }, [searchValue]);
    return (react_1.default.createElement("div", { className: header_search_bar_module_scss_1.default.searchWrapper },
        react_1.default.createElement(cgui_core_atoms_input_1.Input, { className: (0, classnames_1.default)(header_search_bar_module_scss_1.default.search, className), name: "header-search-bar", id: "header-search-bar", placeholder: placeholder, icon: getSearchBarIcon(searchValue.length), inputSize: inputSize, onInputChange: setSearchValue, value: searchValue, onIconClick: () => setSearchValue(""), onKeyDown: handleKeyDown, disabled: disabled, autoFocus: autofocus, ref: ref })));
});
exports.default = HeaderSearchBar;
//# sourceMappingURL=header-search-bar.js.map